export default "skymp5-front/8146df02d428f22a512ecfc1702f3449.png";